import {Button, Form} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import API from "../api/api"
import {useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";


function Login() {
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    async function handleLogin(event) {
        event.preventDefault();
        let username = event.target.username.value;
        let password = event.target.password.value;

        API.get("users/authenticate-user", {
            headers: {
                username: username,
                password: password
            }
        }).then(response => {
            if (response.status === 200) {
                localStorage.setItem("username", username);
                localStorage.setItem("password", password);
                if (searchParams.get("redirect_url")) {
                    console.log(searchParams.get("redirect_url"));
                    window.location = searchParams.get("redirect_url");

                    return;
                }
                navigate("/");
                window.location.reload();
            }
        }).catch(error => {
            if (error.status === 401) {
                setError("Unauthorized");
            }
        })
    }

    return (
        <div className="bg-gradient-dark text-white">
            <Container className="d-flex justify-content-center align-items-center p-5 flex-column"
                       onChange={(e) => setError("")}>
                <p className="display-2 fw-bold text-white mb-5">Login</p>
                <Form className="shadow p-5 rounded text-center fw-bolder"
                      style={{background: "rgba(255, 255, 255, 0.1)"}} onSubmit={handleLogin}>
                    <Form.Group className="mb-3" controlId="formGridUsername">
                        <Form.Label>Username</Form.Label>
                        <Form.Control required name="username" placeholder="username"/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGridPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control required name="password" type="password" placeholder="Password"/>
                    </Form.Group>
                    {error === "Unauthorized" && (
                        <Form.Text className="text-danger">
                            Invalid username or password
                        </Form.Text>
                    )}

                    <Button variant="primary" className="bg-warning w-100 fw-bold" type="submit">
                        Login
                    </Button>
                </Form>
            </Container>

        </div>
    );
}

export default Login;